// You can choose any icon from this list: https://react-icons.github.io/react-icons
import {
  FaSkullCrossbones,
  FaAngleDown,
  FaCode,
  FaCommentDots,
  FaEnvelope,
  FaGithub
} from 'react-icons/fa';

import { MdSecurity } from "react-icons/md";

import {
  SiHackthebox,
  SiTryhackme
} from "react-icons/si";

// This is the color list you can use for now: https://mui.com/material-ui/customization/color/
import {
  amber,
  red,
  grey
} from '@mui/material/colors';

//import Youtube from './components/Youtube'

// @TODO: Create colorset for light and dark modes.
// @TODO: Properly use button and icon colors or maybe even ditch out
const colors = {
  "mode": "dark",
  "primary": red,
  "secondary": amber,
  "button": red,
  "icon": red
}

const icons = [
  {
    "tooltip": "Send me a e-mail!",
    "icon": <FaEnvelope />,
    "route": "email",
    "hidden": false
  },
  {
    "tooltip": "SeC",
    "icon": <FaSkullCrossbones />,
    "route": "www",
    "color": grey[900]
  }
]

// @TODO: maybe create a grouping option?

const items = [
  {
    "title": "// whoami",
    "content": "Brazilian, Ethical Hacker.<p>I've been fascinated by computers since I was a child. As a result, I now enjoy improving things with I.T.</p><br/><small style='font-style:italic; float: right'>sein und dauern.</small><br/>",
    "icon": <FaAngleDown />,
    "type": "accordion",
    "expanded": true
  },
  {
    "title": "I.T.",
    "content": "My journey into the I.T. World!",
    "icon": <FaCode />,
    "route": "it",
    "type": "link",
  },
  {
    "title": "Blog",
    "content": "My personal blog!",
    "icon": <FaCommentDots />,
    "route": "blog",
    "type": "link",
  },
  {
    "title": "GitHub",
    "content": "@osouza-de | my code house.",
    "icon": <FaGithub />,
    "route": "github",
    "type": "link",
  },
  {
    "title": "HackTheBox",
    "content": "My HTB profile page.",
    "icon": <SiHackthebox />,
    "route": "hackthebox",
    "type": "link",
  },
  {
    "title": "SOC Simulator",
    "content": "My SOC Simulator profile page.",
    "icon": <MdSecurity />,
    "route": "socsimulator",
    "type": "link"
  },
  {
    "title": "TryHackMe",
    "content": "My THM profile page.",
    "icon": <SiTryhackme />,
    "route": "tryhackme",
    "type": "link",
    "hidden": false
  }
]

const config = {
  "avatar": "https://avatars.githubusercontent.com/u/7597013?v=4",
  "title": "D. Anderson de Souza",
  colors,
  icons,
  items
}

export default config
